export const routes = {
  home: '/diagonal-growth',
  overview: '/overview',
  login: 'login',
  logout: 'logout',
};

export const publicPages = [
  '/login',
  '/authenticate',
];
